import '@/vendor/wangEditorV2/css/wangEditor.css'
import WangEditor from '@/vendor/wangEditorV2/js/wangEditor'

export default {
  name: 'wangEditor',
  props: {
    value: {
      type: String,
    },
    tag: {
      type: String,
      default: 'div',
    },
    menus: {
      type: Array,
      default: () => [],
    },
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: {
      type: Array,
      default: () => {},
    },
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: {
      type: Object,
      default: () => {},
    },
    zIndex: {
      type: Number,
      default: 1,
    },
  },
  data () {
    return {
      editor: null,
    }
  },
  watch: {
    value () {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.$txt.html()) {
        this.editor.$txt.html(this.value)
      }
    },
  },
  mounted () {
    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new WangEditor(this.$el)

    this.editor.onchange = () => {
      let html = this.editor.$txt.html()
      if (html !== this.value) {
        this.$emit('input', html)
      }
    }

    // 配置数据
    this.editor.config.menus = ['source', 'pasteText', '|', 'bold', 'underline', 'italic', 'eraser', 'forecolor', '|', 'head', '|', 'link', 'unlink', '|', 'undo', 'redo', '|', ...this.menus]
    this.editor.config.colors = {
      '#333': '深灰色',
      '#f3605b': '红色',
      ...this.colors
    }
    // 创建编辑器
    this.editor.create()
    // 赋初始值
    this.editor.$txt.html(this.value)
  },
  destroyed () {
    // 销毁编辑器
    this.editor.destroy()
  },
  render (h) {
    return h(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/components/WangEditorV2Deprecated.js